// extracted by mini-css-extract-plugin
export default {"options":"three-dot-button_options__rHTmV","isActive":"three-dot-button_isActive__W6-9j"};